// Simple Local Storage Wishlist
const Wishlist = {
  // Key used in LocalStorage
  key: 'my_shop_wishlist',

  // Get current list
  get: function() {
    const list = localStorage.getItem(this.key);
    return list ? JSON.parse(list) : [];
  },

  // Save list
  save: function(list) {
    localStorage.setItem(this.key, JSON.stringify(list));
    this.updateCount();
    this.updateButtons();
  },

  // Add item
  add: function(productHandle) {
    let list = this.get();
    if (list.indexOf(productHandle) === -1) {
      list.push(productHandle);
      this.save(list);
    }
  },

  // Remove item
  remove: function(productHandle) {
    let list = this.get();
    const index = list.indexOf(productHandle);
    if (index > -1) {
      list.splice(index, 1);
      this.save(list);
    }
  },

  // Toggle item (Main function called by button)
  toggle: function(button) {
    const productHandle = button.dataset.product;
    const list = this.get();
    
    if (list.includes(productHandle)) {
      this.remove(productHandle);
    } else {
      this.add(productHandle);
    }
  },

  // Update the heart icons on the page
  updateButtons: function() {
    const list = this.get();
    const buttons = document.querySelectorAll('.wishlist_btn');
    
    buttons.forEach(btn => {
      const handle = btn.dataset.product;
      if (list.includes(handle)) {
        btn.classList.add('active'); // Add CSS class for "Filled Heart"
        // Optional: Change icon to filled if using SVG switching
      } else {
        btn.classList.remove('active');
      }
    });
  },
  
  // Update a counter in the header (if you have one)
  updateCount: function() {
    const list = this.get();
    const counters = document.querySelectorAll('.wishlist-count');
    counters.forEach(c => c.innerText = list.length);
  }
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  Wishlist.updateButtons();
  Wishlist.updateCount();
  
  // Attach Click Listeners to all Heart Buttons
  // Use event delegation in case products are loaded via AJAX (filters)
  document.body.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist_btn');
    if (btn) {
      e.preventDefault(); // Stop the link from going to /account/login
      Wishlist.toggle(btn);
    }
  });
});